import { Component } from '@angular/core';

@Component({
  selector: 'app-wallet-small',
  templateUrl: './wallet-small.component.html',
  styleUrls: ['./wallet-small.component.scss']
})
export class WalletSmallComponent {

}
